import { render } from "./VoiceMessageBubble.vue?vue&type=template&id=5585cb6a&scoped=true"
import script from "./VoiceMessageBubble.vue?vue&type=script&lang=js"
export * from "./VoiceMessageBubble.vue?vue&type=script&lang=js"

import "./VoiceMessageBubble.vue?vue&type=style&index=0&id=5585cb6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5585cb6a"]])

export default __exports__